import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithUserGroupProductPackageAssignments = { userGroupProductPackageAssignments: FilterState };

const userGroupProductPackageAssignments = createSlice({
    name: 'userGroupProductPackageAssignments',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userGroupProductPackageAssignments.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userGroupProductPackageAssignments.actions;
export const selectFilters = (state: StateWithUserGroupProductPackageAssignments) => state.userGroupProductPackageAssignments.filters;
